import { Outlet, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import i18n from '../../i18n';

export default function LayoutWithLang() {
    const { lang } = useParams();

    useEffect(() => {
        // Здесь меняем язык в i18n при смене URL
        if (lang && ['en', 'ru'].includes(lang)) {
            i18n.changeLanguage(lang);
        }
    }, [lang]);

    return <Outlet />; // рендер вложенных роутов
}
